import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class StorageLocationService {
    private _currentLocation = new BehaviorSubject<any>(null);
    private _currentLocation$ = this._currentLocation.asObservable();
    private URL: string = '/api/storage-location';

    constructor(private httpService: HttpClient) {
    }

    create(storageLocation: any) {
        return this.httpService.post(this.URL, storageLocation);
    }

    getAll() {
        return this.httpService.get(this.URL);
    }

    getAdminAll() {
        return this.httpService.get(`${this.URL}/admin-all`);
    }

    getOne(id: string) {
        return this.httpService.get(`${this.URL}/${id}`);
    }

    update(id: string, storageLocation: any) {
        return this.httpService.patch(`${this.URL}/${id}`, storageLocation);
    }

    delete(id: string) {
        return this.httpService.delete(`${this.URL}/${id}`);
    }

    setCurrentLocation(location) {
        this._currentLocation.next(location);
    }

    getCurrentLocation(): Observable<any> {
        return this._currentLocation$;
    }
}
